import { DocumentRevision } from '../types';

export const WORKFLOW_ASSIGNMENT_CONFLICT_ERROR =
  'Cannot start a revision workflow while another revision already has a workflow assigned. Complete or clear the active revision workflow first.';

export function isRevisionStarted(revision: DocumentRevision): boolean {
  const status = (revision.status || '').toLowerCase();
  if (status === 'approved') {
    return false;
  }
  return Boolean(revision.has_workflow);
}

export function hasStartedRevision(revisions: DocumentRevision[]): boolean {
  return revisions.some(isRevisionStarted);
}

export function getNextRevisionCounter(
  revisions: Array<{ revision_counter?: number | null }>
): number {
  if (!revisions.length) return 0;
  return Math.max(...revisions.map((r) => r.revision_counter ?? 0)) + 1;
}
